import { gql } from '@apollo/client'

export const GENERATE_MULTIPLE_RATE_PLAN_MUTATION = gql`
  mutation GenerateMultipleRatePlan(
    $input: MultipleRatePlanInput!
    $propertyCode: String!
    $roomTypeCode: String!
  ) {
    generateMultipleRatePlan(
      input: $input
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
    ) {
      trackingID
    }
  }
`
